import { render, staticRenderFns } from "./DemoTreeviewColor.vue?vue&type=template&id=ca45b4b4&"
import script from "./DemoTreeviewColor.vue?vue&type=script&lang=js&"
export * from "./DemoTreeviewColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VTreeview})
